/**
 * Navigation utilities for React Router
 *
 * This file provides React Router equivalents for Next.js navigation hooks
 * to maintain compatibility with existing code during the migration.
 */

import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";

export { RouterLink as Link };

/**
 * React Router equivalent of Next.js useRouter()
 * Returns an object with push, replace, back, forward, and refresh methods
 */
export function useRouter() {
    const navigate = useNavigate();

    return {
        push: (href: string, options?: { scroll?: boolean }) => {
            navigate(href, { preventScrollReset: options?.scroll === false });
        },
        replace: (href: string) => navigate(href, { replace: true }),
        back: () => navigate(-1),
        forward: () => navigate(1),
        refresh: () => navigate(0), // Navigate to current location (triggers reload)
    };
}

/**
 * React Router equivalent of Next.js usePathname()
 * Returns the current pathname
 */
export function usePathname() {
    const location = useLocation();
    return location.pathname;
}

// Client-side redirect helper
export function redirect(href: string) {
    if (typeof window !== "undefined") {
        window.location.href = href;
    }
}
